import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/w/entity-templates/view/$templateId')({
  staticData: {
    breadcrumb: 'View Template',
    breadcrumbKey: 'K_BREADCRUMB_VIEW_TEMPLATE',
  },
});
